import { setBearerToken } from '@/http'

//token
export const setHeaderToken = token => setBearerToken(token)
export const getLocalToken = () => localStorage.getItem('token')
export const deleteLocalToken = () => localStorage.removeItem('token')
export const setLocalToken = token => localStorage.setItem('token', token)
//user
export const setLocalUser = user => localStorage.setItem('user', JSON.stringify(user)) 
export const getLocalUser = user => localStorage.getItem('user', JSON.stringify(user))
export const getLocalUserId = () => localStorage.getItem('id_user')
export const deleteLocalUser = () => localStorage.removeItem('user')
export const deleteLocalUserId = () => localStorage.removeItem('id_user')
